export const validate = (cardDetails, setInputErr) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const errors = [];

    Object.keys(cardDetails).forEach(key => {
        if (!cardDetails[key]) {
            if (key === "state" && ["us", "mx", "ca"].includes(cardDetails.country.toLowerCase())) {
                errors.push({ [key]: `${key} is required` });
            } else if ((key !== "state") && key !== "id") {
                errors.push({ [key]: `${key} is required` });
            }
        } else {
            if (key === "card_number" && cardDetails[key].length < 19) {
                errors.push({ "card_number": `Please enter a 16-digit card number` });
            } else if (key === "expiry_month") {
                if (Number(cardDetails.expiry_month) > 12) {
                    errors.push({ "expiry_month": `Please enter a valid month (1-12)` });
                } else if (
                    Number(cardDetails.expiry_year) === currentYear &&
                    Number(cardDetails.expiry_month) < currentMonth
                ) {
                    errors.push({ "expiry_month": `The expiration date cannot be in the past` });
                }
            } else if (key === "expiry_year") {
                if (!/^\d{4}$/.test(cardDetails.expiry_year)) {
                    errors.push({ "expiry_year": `Expiration year must be a 4-digit number` });
                } else if (Number(cardDetails.expiry_year) < currentYear) {
                    errors.push({ "expiry_year": `The expiration year cannot be in the past` });
                }
            } else if (key === "cvc" && cardDetails.cvc.length < 3) {
                errors.push({ "cvv": `CVV must be at least 3 digits` });
            }
        }
    });   
    setInputErr(errors);
};